"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
import { useMatchPageData } from "../../context/MatchPageDataContext";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
interface PlayerLinkProps {
  playerId?: string;
  children: React.ReactNode;
  className?: string;
  inheritColor?: boolean;
}

/**
 * Wraps children in a Link to the player page if a mapping exists.
 * Falls back to a plain span if no mapping is found.
 */
export const PlayerLink: React.FC<PlayerLinkProps> = t0 => {
  const $ = _c(12);
  const {
    playerId,
    children,
    className,
    inheritColor
  } = t0;
  const {
    playerIdMap
  } = useMatchPageData();
  const nav = useNavigation();
  const nativeId = playerId ? playerIdMap[playerId] : undefined;
  let t1;
  if ($[0] !== nativeId || $[1] !== nav) {
    t1 = nativeId ? nav.player(nativeId) : undefined;
    $[0] = nativeId;
    $[1] = nav;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const href = t1;
  if (href) {
    const colorClass = inheritColor ? "" : "link-neutral";
    const t2 = `${colorClass} hover:underline ${className || ""}`;
    let t3;
    if ($[3] !== t2) {
      t3 = t2.trim();
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== children || $[6] !== href || $[7] !== t3) {
      t4 = <Link href={href} prefetch={false} className={t3}>{children}</Link>;
      $[5] = children;
      $[6] = href;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  let t2;
  if ($[9] !== children || $[10] !== className) {
    t2 = <span className={className}>{children}</span>;
    $[9] = children;
    $[10] = className;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};